<template>
<!-- <div>It's working!</div> -->
<div>
    <b-container>
        <b-row><b-col><b-img
                class="logo"
                :src="logo.path"
                alt="Main Logo"
            /></b-col></b-row>
        <b-row class="reminder-group">
            <b-col>
            <h2>No Invite Found</h2>
            <p class="reminder-container">It looks like you're trying to set up a seller account.</p>
            <p class="reminder-container"><span class="bold-reminder">No account yet?</span> Have your agent invite you to start your forms.</p>
            </b-col>
        </b-row>
        <b-row class="reminder-group">
            <b-col>
            <p class="reminder-container"><span class="bold-reminder">Already invited?</span> Check to make sure you're using the email address provided in the invitation. </p>
            <p class="reminder-container">You can update this later in your account.</p>
            </b-col>
        </b-row>
        <b-row class="reminder-group">
            <b-col>
            <p class="reminder-container"><span class="bold-reminder">Just want to purchase HSLP?</span> Visit<a href="https://sellersshield.com/home/home-sellers/"> Sellers Shield</a>.</p>
            </b-col>
        </b-row>
        <b-row class="reminder-group">
            <b-col>
            <p class="reminder-container"><span class="bold-reminder">Still need help?</span> <a href="https://sellersshield.com/home/contact/">Contact support</a> if you need help getting started.</p>
            </b-col>
        </b-row>
        <b-row class="d-flex justify-content-center">
            <b-btn
                :disabled="loading"
                pill
                size="lg"
                type="button"
                class="white-button"
                @click="goBack"
            >
            Back
            </b-btn>
        </b-row>
    </b-container>
</div>
</template>

<script>
import "./NotInvitedSeller.scss";


export default {
    name: 'NotInvitedSeller',
    props: {
        errors: {
            type: Array,
            required: false,
            default: () => ([])
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data: () => ({
        logo: {
            path: require('@assets/images/ss-wordmark-black.png'),
        },
        background: {
            path: require('@assets/images/Rectangle1.png'),
        },
    }),
    methods:{
        goBack() {
          this.$emit('welcome');
        }
    }
}
</script>